import React from 'react';
import PasswordResetForm from 'components/authentication/PasswordResetForm';

const PasswordReset = () => (
  <div className="text-center">
    <h5>Restablecer Contraseña Nueva</h5>
    <PasswordResetForm />
  </div>
);

export default PasswordReset;
